<div class="p-3" style="min-width: 500px">
  <div class="d-flex align-items-center justify-content-between mb-3">
    <h5 class="mb-0">
      {{ adapterData.isUpdate ? 'Edit' : ' Add New' }}
      Adapter Setting
    </h5>
    <img
      src="assets/images/close-icon.svg"
      alt="close-icon"
      class="cursor-pointer"
      [attr.aria-hidden]="true"
      (click)="closeDialogRef.close({ success: false })" />
  </div>

  <form
    class="mat-form"
    [formGroup]="upsertAdapterSettingFrom"
    (ngSubmit)="onSubmit()">
    <div class="row">
      <div class="col-md-12 form-group">
        @if (adapterData.isUpdate) {
          <app-input-template
            [inputData]="attrConstant.adapter"
            [formControlName]="attrConstant.adapter.key"></app-input-template>
        } @else {
          <app-input-select
            (selectionChange)="onAdapterChange($event)"
            [inputData]="attrConstant.code"
            [selectOptions]="adapterSettings"
            [bindLabel]="'name_type'"
            [bindValue]="'code'"
            [formControlName]="attrConstant.code.key"></app-input-select>
        }
      </div>
      @for (data of selectedAdapterSettings; track $index) {
        <div class="col-md-12 form-group">
          @switch (data.kind) {
            @case ('boolean') {
              <div class="toggle-row">
                <mat-slide-toggle [formControlName]="data.name">
                  {{ data.name | formatText }}
                </mat-slide-toggle>
              </div>
            }
            @case ('json') {
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>{{ data.name | formatText }}</mat-label>
                <textarea
                  matInput
                  rows="4"
                  [formControlName]="data.name"></textarea>
                @if (data.control.hasError('invalidJson')) {
                  <mat-error>Invalid JSON</mat-error>
                } @else if (data.control.hasError('required')) {
                  <mat-error>Required</mat-error>
                }
              </mat-form-field>
            }
            @default {
              <mat-form-field appearance="outline">
                <mat-label>{{ data.name | formatText }}</mat-label>
                <input
                  matInput
                  [type]="data.inputType"
                  [formControlName]="data.name" />
              </mat-form-field>
            }
          }
        </div>
      }
    </div>
    <div class="row mt-3 justify-content-end">
      <div class="col-md-6">
        <button
          class="btn primary-btn w-100"
          [disabled]="isDataLoading || isSubmitLoading"
          [ngClass]="isDataLoading || isSubmitLoading ? 'dsbld' : 'enbld'">
          <img
            *ngIf="isSubmitLoading"
            src="assets/images/button-spinner.svg"
            alt="button-spinner" />{{ adapterData.isUpdate ? 'Update' : 'Add' }}
        </button>
      </div>
    </div>
  </form>
</div>
